
import moment from 'moment';

export const formatDate = (d) => {
  if (d instanceof Date) {
    return moment(d).format('DD/MM/YYYY');
  }
  return null;
};
